import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { forkJoin } from 'rxjs';
import { MessageNotificationType } from 'src/app/enum/message-notification-type';
import { BulkMessageService } from 'src/app/services/bulk-message.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import * as _ from "lodash";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import saveAs from 'file-saver';
import moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { NotificationService } from 'src/app/services/notification-service';
import { ExcelService } from 'src/app/services/excel.service';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { AdditionalFeaturesPopupComponent } from '../additional-features-popup/additional-features-popup.component';
import { animate, state, style, transition, trigger } from '@angular/animations';


@Component({
    selector: 'app-messaging',
    templateUrl: './messaging.component.html',
    styleUrls: ['./messaging.component.scss'],
    animations: [
        trigger('detailExpand', [
          state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
          state('expanded', style({ height: '*', display: 'block', padding: '15px' })),
          transition('expanded <=> collapsed', animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
      ],
})
export class MessagingComponent implements OnInit {
    serviceQueue = []
    tempindividualOrGroupList: any = [];
    tempnotificationTypeList: any = [];
    notificationTypeList: any = []
    individualOrGroupList: any = []
    messageList: any = [];
    data: any = []
    dataExcel: any = []
    filterOpen: boolean = false
    dataSource = new MatTableDataSource(this.data);
    MessageNotificationTypeEnum = MessageNotificationType;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    hcmessageForm: FormGroup
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    filteredList1: any
    filteredList2: any
    toMinDate: any;
    toMaxDate: any;
    displayedColumns: string[] = [
        'MessagingType',
        'NotificationType',
        'Recipient',
        'Status',
        'Action',
    ];
    excelColumns: string[];
    showfilter=false;
    constructor(private lookupDataService: LookupDataServiceService, private bulkMessageService: BulkMessageService, private navigation: NavigationService,
        private loaderService: LoaderService, private fb: FormBuilder, private toastr: NotificationService, private excelService: ExcelService,
        private matdialog:MatDialog
    ) { }

    ngOnInit() {
        this.init()
        this.loadServiceQueue();
        this.getTableData('')
        this.executeServiceQueue();
        // templatepath = "app/checkcoverage/messaging/homemessagingFilters.html";
    }
    filtertoggle(){
        this.showfilter=this.showfilter?false:true
    }
    init() {
        this.hcmessageForm = this.fb.group({
            startDate: [null],
            endDate: [null],
            messagingType: [null],
            messageNotificationType: [null]
        });
    }
    getTableData(data) {
        this.bulkMessageService.getMessageList(data).subscribe((results: any) => {
            this.messageList = results;
            this.data = results;
            this.dataExcel = results;
            // this.data = _.orderBy(this.data, ["message"]);
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }
    loadServiceQueue() {
        this.serviceQueue.push(this.lookupDataService.getIndividualOrGroup());
        this.serviceQueue.push(this.lookupDataService.getNotificationTypeList());

    }
    executeServiceQueue() {
        forkJoin(this.serviceQueue).subscribe((serviceResponse: any) => {
            this.tempindividualOrGroupList = serviceResponse[0];
            this.tempnotificationTypeList = serviceResponse[1]
            this.tempnotificationTypeList.forEach(item => {
                if (item.key == 2 || item.key == 3) {
                    this.notificationTypeList.push(item)
                    this.filteredList2 = this.notificationTypeList
                }
            });
            this.tempindividualOrGroupList.forEach(item => {
                if (item.key == 1 || item.key == 2) {
                    this.individualOrGroupList.push(item)
                    this.filteredList1 = this.individualOrGroupList
                }
            });
        });
    }
    Reset() {
        this.hcmessageForm.reset()
        this.getTableData('')
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.hcmessageForm.controls["startDate"].value;
        // this.toMaxDate = this.addMonths(this.toMinDate, 3);
    }
    addMessage() {
        // this.navigation.gotoMessage();
        // gotomessage add
    }
    viewMail(message) {
        this.matdialog.open(AdditionalFeaturesPopupComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: 'mat-dialog',
            width: "30%",
            data: {
                title: 'Messaging Details',
                value:message
            }
        });
    }
    EncryptCustomerMobilenumber(Mobilenumber) {
        var resMob = "";
        var length = Mobilenumber?.length
        var resultString = Mobilenumber;
        var middleXCount = 0;
        var firstTwoChars = "";
        if (Mobilenumber !== "Multiple") {
            if (Mobilenumber !== null) {
                if (length >= 4) {
                    if (Mobilenumber.includes("+27")) {
                        firstTwoChars = Mobilenumber.slice(0, 3);
                        middleXCount = length - 5;
                    }
                    else {
                        firstTwoChars = Mobilenumber.slice(0, 2);
                        middleXCount = length - 4;
                    }
                    var lastTwoChars = Mobilenumber.slice(length - 2);

                    var middleXs = 'x'.repeat(middleXCount);
                    resultString = firstTwoChars + middleXs + lastTwoChars;
                }
            }
        }
        return resultString;
    }
    exportData(): void {
        this.loaderService.start();
        setTimeout(() => {
            console.log(this.dataExcel);
            
            var exportData = this.dataExcel;
            if (!exportData || exportData.length === 0) {
                this.toastr.showInfo("No data available to export");
                this.loaderService.hide();
                return;
            }
            const excelList = [];
            this.excelColumns = [
                'MessagingType',
                'NotificationType',
                'Recipient',
                'Status',
                'Message'
            ]

            exportData.forEach((a, index) => {
                excelList.push({
                    "MessagingType": a.messagingTypeString,
                    "NotificationType": a.notificationTypeString,
                    "Recipient": this.EncryptCustomerMobilenumber(a.messagingRecipientString),
                    "Status": a.messageStatusTypeString,
                    "Message": a.message
                });
            });
            this.excelService.exportAsExcelFile(excelList, "HomeConnectMessaging_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
            this.loaderService.stop();
        }, 500);
    }

    getRow(item) {
        var message = "";
        if (item.notificationType == this.MessageNotificationTypeEnum.HtmlEMail) {
            var temparray = item.message.split('Kind');
            var temp = document.createElement("div");
            temp.innerHTML = temparray[0];
            message = temp.textContent || temp.innerText || "";
        }
        else {
            message = item.message;
        }
        return [
            item.messagingTypeString,
            item.notificationTypeString,
            item.messagingRecipientString,
            item.messageStatusTypeString,
            message
        ];
    }
    filterSearchClick() {
        var formValues = this.hcmessageForm.getRawValue();

        if (!(this.hcmessageForm.value.startDate || this.hcmessageForm.value.endDate || this.hcmessageForm.value.messagingType || this.hcmessageForm.value.messageNotificationType)) {
            Swal.fire({
                title: 'Please Select Any Filter',
                icon: 'warning',
                position: 'center'
            })
            return
        }
        if (this.hcmessageForm.value.startDate && this.hcmessageForm.value.endDate) {
            if (this.hcmessageForm.value.startDate > this.hcmessageForm.value.endDate) {
                Swal.fire({
                    title: 'End Date should be greater than Start Date',
                    icon: 'warning',
                    position: 'center'
                })
                return
            }
            else {
                formValues.startDate = moment(formValues.startDate).format("YYYY/MM/DD");
                formValues.endDate = moment(formValues.endDate).format("YYYY/MM/DD");
                this.getTableData(formValues)
            }
        } else {
            this.getTableData(formValues)
        }
    }

}
